export default __webpack_public_path__ + "static/media/holidays-nrml.0d0a532e.svg";